<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="small"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_main_fabric_category') || '1级面料分类'"
                prop="mainMaterialCategory"
                ref="mainMaterialForm"
              >
                <dict-select
                  :disabled="disabled"
                  :placeholder="
                    $l('form_placeholder_main_fabric_category') ||
                      '请选择1级面料分类'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.mainMaterialCategory"
                  :body="mainMaterialParams"
                  url="/master/material/category/select"
                  :options="{ label: 'label', value: 'this' }"
                  @change="onMainCategoryChange"
                  @loaded="loaded"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_detail_fabric_category') || '2级面料分类'"
                prop="detailMaterialCategoryCode"
                ref="detailMaterialForm"
              >
                <dict-select
                  :disabled="disabled || !formData.mainMaterialCategoryCode"
                  :placeholder="
                    $l('form_placeholder_detail_fabric_category') ||
                      '请选择2级面料分类'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.detailMaterialCategoryCode"
                  :body="detailMaterialParams"
                  url="/master/material/category/select"
                  @change="reset"
                  @loaded="loadedDetailCategories"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div style="height: 64px;" class="d-flex align-items-end">
                <b-button
                  :disabled="
                    !formData.mainMaterialCategoryCode ||
                      !formData.detailMaterialCategoryCode
                  "
                  size="sm"
                  variant="outline-success"
                  @click="fabricDialogVisible = true"
                >
                  {{ $l('form_label_choose_fabric') || '选择面料' }}
                </b-button>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <div class="d-flex">
        <div class="side-frame"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('form_label_fabric_base_info') || '面料基础信息' }}
          </span>
        </div>
      </div>
      <div class="mt-2 d-flex">
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ formData.materialNo || '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ formData.materialName || '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ formData.materialNameEn || '--' }}
          </span>
        </div>
      </div>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_fabricCompositionChinese') || '面料成分中文'"
            prop="fabricContent"
          >
            <el-input
              readonly
              v-model="formData.displayName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              maxlength="100"
              clearable
              size="small"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                :disabled="fabricPropertiesVisible"
                @click="chooseMasterAttributeDictionary"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form :disabled="fabricPropertiesVisible">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item :label="$l('INDEX.choose_fabric_wid') || '有效门幅'">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="0.01"
                    :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                    v-model="formData.wid"
                  ></el-input-number>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.form_label_fabric_width_unit') || '门幅单位'"
                  prop="widUnit"
                >
                  <dict-select
                    v-model="formData.widUnit"
                    url="/digitalCenter/common/dict/biz"
                    :body="{ dictType: 'widUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    filterable
                    clearable
                  ></dict-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.form_label_fabric_weight') || '面料克重'"
                  prop="fabricWeight"
                >
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="0.01"
                    :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                    v-model="formData.fabricWeight"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('INDEX.form_label_fabricWeightUnit') || '克重单位'"
                >
                  <dict-select
                    v-model="formData.fabricWeightUnit"
                    url="/digitalCenter/common/dict/biz"
                    :body="{ dictType: 'fabricWeightUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    filterable
                    clearable
                  ></dict-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <div class="d-flex mt-3">
        <div class="side-frame"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('form_label_material_price_use') || '单价/耗料' }}
          </span>
        </div>
      </div>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item :label="$l('form_label_price') || '单价'">
            <el-input-number
              v-model="formData.price"
              controls-position="right"
              :min="0"
              :max="999999.999999"
              :placeholder="$l('form_placeholder_price') || '请输入单价'"
              clearable
              :precision="6"
              :step="0.1"
              style="width: 100%;"
              :disabled="!formData.materialNo"
              v-el-inputnumber-default0
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$l('form_label_qty_unit') || '耗料单位'">
            <dict-select
              :placeholder="$l('form_placeholder_qty_unit') || '请选择耗料单位'"
              size="small"
              clearable
              filterable
              v-model="formData.qtyUnit"
              :body="qtyUnitParams"
              url="/master/common/dict/biz"
              :disabled="!formData.materialNo"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$l('form_label_usage_qty') || '耗料'">
            <el-input
              clearable
              v-model="formData.usageQty"
              :disabled="!formData.materialNo"
              size="small"
              @blur="blurUsageQty"
              :placeholder="$l('form_placeholder_usage_qty') || '请输入耗料'"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                :disabled="!formData.materialNo"
                @click="openFormulaDialogVisible"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_sub_total') || '成本小记'">
            <el-input
              v-model="subTotal"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              disabled
              style="width: 100%;"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_manufacturer') || '厂商'">
            <dict-select
              :placeholder="$l('form_placeholder_scm') || '请选择厂商'"
              size="small"
              clearable
              filterable
              v-model="formData.scmCode"
              :body="scmParams"
              url="/master/common/dict/scm"
              :disabled="!formData.materialNo"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.product_dialog_btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <choose-fabric-dialog
      :title="$l('INDEX.material_choose_title') || '添加面料信息'"
      :visible.sync="fabricDialogVisible"
      type="radio"
      @confirm="onFabricConfirm"
    />

    <el-dialog
      ref="ChooseMasterAttributeDictionaryDialog"
      :title="
        $l('dialogTitle_ingredientMaintenanceInformation') || '成分维护信息'
      "
      :visible.sync="ChooseMasterAttributeDictionaryVisible"
      :show-close="true"
      append-to-body
      :close-on-click-modal="false"
      width="1000px"
    >
      <choose-master-attribute-dictionary
        ref="chooseMasterAttributeDictionary"
        @chooseMasterAttributeDictionaryClose="
          chooseMasterAttributeDictionaryClose
        "
        @masterAttributeDictionaryData="masterAttributeDictionaryData"
      />
    </el-dialog>

    <ChooseFormula
      :visible.sync="formulaDialogVisible"
      :title="$l('INDEX.form_label_select_formula') || '选择计算公式'"
      :productLine="productLine"
      :categoryCode="categoryCode"
      type="radio"
      @confirm="formulaConfirm"
    />

    <el-dialog
      v-if="visible"
      :visible.sync="visible"
      append-to-body
      show-close
      width="1100px"
      :title="$l('INDEX.form_label_formula') || '计算公式'"
      :close-on-click-modal="false"
      :before-close="dialogClose"
    >
      <BaseForm
        :formulaCode="formData.formulaCode"
        :dataForm="priceData"
        :disabled="false"
        :materialDisabled="materialDisabled"
        ref="baseForm"
      />
      <span slot="footer">
        <el-button size="small" @click="dialogClose">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import BaseForm from '@/views/backstage/sample/sampleFormula/detail/components/base-form'
import ChooseFormula from '@/views/backstage/sample/sampleInformation/detail/components/sample-material/components/formula-dialog/dialog.vue'
import { multiplyRound } from '@/libs/util.number.js'

export default {
  components: {
    BaseForm,
    ChooseFormula,
  },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    formData: { type: Object, default: () => {} },
    productLine: { type: String, default: '' },
    categoryCode: { type: String, default: '' },
  },
  data() {
    return {
      visible: false,
      formulaDialogVisible: false,
      priceData: {},
      materialDisabled: true,
      fabricDialogVisible: false,
      backDialogVisible: false,
      fabricPropertiesVisible: true,
      ChooseMasterAttributeDictionaryVisible: false,
      scmParams: {},
      subTotal: 0,
      qtyUnitParams: { dictType: 'widUnit' },
      rules: {
        mainMaterialCategory: [
          {
            required: true,
            message:
              this.$l('form_placeholder_main_fabric_category') ||
              '请选择1级面料分类',
            trigger: 'change',
          },
        ],
        detailMaterialCategoryCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_detail_fabric_category') ||
              '请选择2级面料分类',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    'formData.mainMaterialCategory': {
      handler(data) {
        this.$set(
          this.formData,
          'mainMaterialCategoryCode',
          data ? data.value : ''
        )
      },
      immediate: true,
    },
    'formData.materialNo': {
      handler(val) {
        this.fabricPropertiesVisible = !val
      },
      immediate: true,
    },
    'formData.metadataDesc': {
      handler() {
        this.parseFabricMetadata()
      },
      immediate: true,
    },
    'formData.price': {
      handler() {
        this.CostCalculation()
      },
      immediate: true,
    },
    'formData.usageQty': {
      handler() {
        this.CostCalculation()
      },
      immediate: true,
    },
  },
  computed: {
    mainMaterialParams() {
      return {
        parentCode: this.formData.productLine,
        materialType: 'F',
      }
    },
    detailMaterialParams() {
      return {
        parentCode: this.formData.mainMaterialCategoryCode,
      }
    },
  },
  methods: {
    loaded(options = []) {
      if (this.formData.mainMaterialCategory || options.length !== 1) return

      const [option] = options
      this.formData.mainMaterialCategory = option.value
      this.onMainCategoryChange(option.value)
    },
    loadedDetailCategories(options = []) {
      if (this.formData.detailMaterialCategoryCode || options.length !== 1) {
        return
      }

      const [option] = options
      this.formData.detailMaterialCategoryCode = option.value
      this.reset()
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (!this.formData.materialNo) {
        this.$message.error(
          this.$l('form_placeholder_fabric') || '请选择面料！'
        )
        return
      }
      if ((this.formData.wid || this.formData.wid === 0) && !this.formData.widUnit) {
        this.$message.error(
          this.$l('INDEX.rule_tips_widUnit') || '请选择门幅单位'
        )
        return
      }
      if (
        (this.formData.fabricWeight || this.formData.fabricWeight === 0) &&
        !this.formData.fabricWeightUnit
      ) {
        this.$message.error(
          this.$l('INDEX.rule_tips_fabricWeightUnit') || '请选择面料克重单位'
        )
        return
      }

      this.formData.metadataDesc =
        (this.formData.wid || this.formData.wid === 0 ? this.formData.wid : '') +
        ' ' +
        (this.formData.widUnit || '') +
        '/' +
        (this.formData.fabricWeight || this.formData.fabricWeight === 0
          ? this.formData.fabricWeight
          : '') +
        ' ' +
        (this.formData.fabricWeightUnit || '')
      this.formData.metadataDescEn = this.formData.metadataDesc

      this.loadingOpen()
      this.submitSave({
        ...this.formData,
        materialType: 'F',
        subTotal: this.subTotal,
      })
        .then((res) => {
          this.loadingClose()
          if (res.status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('reload')
            this.close()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async submitSave(params) {
      if (this.formData.proofingCode) {
        return await this.$api.proofingSampleMaterialSaveApi(params)
      }
      return await this.$api.sampleInfoMaterialSaveApi(params)
    },
    onFabricConfirm(data) {
      this.fabricPropertiesVisible = false
      const metadataDesc =
        data.wid + ' ' + data.widUnit + '/' + data.fabricWeight + ' ' + data.fabricWeightUnit

      this.changeFormData({
        price: data.unitPrice,
        qtyUnit: data.fabricUnit,
        materialCode: data.fabricCode,
        materialNo: data.fabricNo,
        materialName: data.fabricName,
        materialNameEn: data.fabricNameEn,
        displayName: data.fabricContent,
        displayNameEn: data.fabricContentEn,
        metadataDesc,
        metadataDescEn: metadataDesc,
        scmCode: data.supCode,
        wid: data.wid || undefined,
        widUnit: data.widUnit,
        fabricWeight: data.fabricWeight || undefined,
        fabricWeightUnit: data.fabricWeightUnit,
        materialDesc: '',
        materialSpec: '',
        materialType: 'F',
      })
    },
    changeFormData(data) {
      const {
        sampleMaterialCode,
        sampleCode,
        proofingCode,
        sortOrder,
        productLine,
        mainMaterialCategoryCode,
        detailMaterialCategoryCode,
        mainMaterialCategory,
      } = this.formData

      const formData = {
        sampleMaterialCode,
        sampleCode,
        proofingCode,
        sortOrder,
        productLine,
        mainMaterialCategoryCode,
        detailMaterialCategoryCode,
        mainMaterialCategory,
        materialType: 'F',
        ...data,
      }
      this.$emit('change', formData)
      this.$emit('update:formData', formData)
      this.CostCalculation()
    },
    reset() {
      this.changeFormData({
        materialNo: '',
        materialName: '',
        materialNameEn: '',
        displayName: '',
        displayNameEn: '',
        metadataDesc: '',
        metadataDescEn: '',
        materialDesc: '',
        materialSpec: '',
        price: 0,
        qtyUnit: '',
        usageQty: '',
        scmCode: '',
        wid: undefined,
        widUnit: '',
        fabricWeight: undefined,
        fabricWeightUnit: '',
        formulaCode: '',
      })
      this.fabricPropertiesVisible = true
    },
    onMainCategoryChange(value = this.formData.mainMaterialCategory) {
      this.$set(
        this.formData,
        'mainMaterialCategoryCode',
        value ? value.value : ''
      )
      this.formData.detailMaterialCategoryCode = ''
      this.$refs.detailMaterialForm.resetField()
      this.reset()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    chooseMasterAttributeDictionary() {
      this.ChooseMasterAttributeDictionaryVisible = true
      const queryParams = {
        attributeType: 'Content',
        attributeStatusArray: ['Y'],
      }
      this.$nextTick(() => {
        this.$refs.chooseMasterAttributeDictionary.loadData(queryParams)
      })
    },
    chooseMasterAttributeDictionaryClose() {
      this.ChooseMasterAttributeDictionaryVisible = false
    },
    masterAttributeDictionaryData(data) {
      this.formData.displayName = data.attributeName
      this.formData.displayNameEn = data.attributeNameEn
    },
    dialogClose() {
      this.visible = false
    },
    parseFabricMetadata() {
      if (!this.formData.metadataDesc) return
      const [
        [widWeight = '', widUnit = ''] = [],
        [fabricWeight = '', fabricWeightUnit = ''] = [],
      ] = this.formData.metadataDesc
        .split(/(?!g)\/(?!m)/)
        .map((item) => item.split(' '))
      this.formData.wid = widWeight
      this.formData.widUnit = widUnit
      this.formData.fabricWeight = fabricWeight
      this.formData.fabricWeightUnit = fabricWeightUnit
    },
    openFormulaDialogVisible() {
      if (!this.formData.fabricWeight) {
        this.$message.warning(
          this.$l('INDEX.rule_tips_fabricWeight_shall_be_greater_than_0') ||
            '面料克重应大于0'
        )
        return
      }
      if (this.formData.proofingCode) {
        this.$api
          .proofingSampleInfoDetailApi({ sampleCode: this.formData.sampleCode })
          .then((res) => {
            this.priceData.specLength = res.body.specLength || ''
            this.priceData.specWidth = res.body.specWidth || ''
            this.priceData.specHeight = res.body.specHeight || ''
            this.priceData.sampleSizeUnit = res.body.sampleSizeUnit || ''
            this.priceData.sampleWeight = this.formData.fabricWeight || ''
            this.priceData.price = this.formData.price
          })
      } else {
        this.$api.sampleInfoDetailApi({ sampleCode: this.formData.sampleCode }).then((res) => {
          this.priceData.specLength = res.body.specLength || ''
          this.priceData.specWidth = res.body.specWidth || ''
          this.priceData.specHeight = res.body.specHeight || ''
          this.priceData.sampleSizeUnit = res.body.sampleSizeUnit || ''
          this.priceData.sampleWeight = this.formData.fabricWeight || ''
          this.priceData.price = this.formData.price
        })
      }
      this.formulaDialogVisible = true
    },
    formulaConfirm(data) {
      this.formData.formulaCode = data.formulaCode
      this.visible = true
    },
    async confirm() {
      await this.$refs.baseForm.getSum().then((res) => {
        if (res) {
          this.formData.usageQty = res.usageQty
          this.formData.price = res.price
          this.visible = false
        }
      })
      this.CostCalculation()
    },
    CostCalculation() {
      if (!this.formData) return 0
      const { price, usageQty } = this.formData
      this.subTotal = multiplyRound(price, usageQty, 6)
    },
    blurUsageQty() {
      const num = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
      if (!num.test(this.formData.usageQty)) {
        this.formData.usageQty = 0
        this.subTotal = 0
        return
      }
      if (this.formData.usageQty > 999999.999999) {
        this.formData.usageQty = 999999.999999
      }
      this.formData.usageQty = parseFloat(this.formData.usageQty).toFixed(6)
    },
  },
}
</script>

<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
